<template>
  <h1>{{ title }}</h1>
</template>

<script>

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default {
  name: "titleComponent",
  props: {
    keyword: {
      type: String,
      default: null
    },
  },
  computed: {
    title: function () {
      return `${capitalize(this.keyword)} Table`;
    },
  },
}
</script>

<style scoped>

</style>